import React from 'react';
import { imageTextVariantsMap } from './const';
import { ImageTextProps } from './types';

const RenderImageText: React.FC<ImageTextProps> = (props) => {
  const fallbackVariant =
    props.variant && props.variant in imageTextVariantsMap
      ? props.variant
      : 'image';

  const ImageTextComponent = imageTextVariantsMap[fallbackVariant];

  return ImageTextComponent ? (
    <ImageTextComponent data-component-id="C023" {...props} />
  ) : null;
};

export default RenderImageText;
